import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27d5891b"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "tab_item_text" }

import { useRoute, useRouter } from 'vue-router';

export default /*#__PURE__*/_defineComponent({
  __name: 'TabBar',
  props: {
  isLink: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props



const route = useRoute();
const router = useRouter();

const tabItems = [
  { label: '職務経歴', path: '/menu/resume-company/', prefix: 'resume-company' },
  { label: '希望条件', path: '/menu/desired/', prefix: 'desired' },
  { label: '学歴・スキル', path: '/menu/education-skill/', prefix: 'education-skill' },
];
const transitionPage = (path: string) => {
  if (!props.isLink) {
    return;
  }
  router.push(path);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tab", { 'is-link': __props.isLink }])
  }, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabItems, (item) => {
      return _createElementVNode("div", {
        key: item.prefix,
        class: _normalizeClass(["tab_item", { 'is-current': _unref(route).path.includes(item.prefix) }]),
        onClick: ($event: any) => (!_unref(route).path.includes(item.prefix) ? transitionPage(item.path) : '')
      }, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(item.label), 1)
      ], 10, _hoisted_1)
    }), 64))
  ], 2))
}
}

})